import { IBulkEmailAttachment } from '../../BulkEmailService';

export interface IEmailReplyPrompt {
  prompt: string;
  promptTitle: string;
  isActive: boolean;
}

export interface IAutomatedEmailCampaignSetting {
  id: string;
  jobId: string;
  clientId: string;
  clientContactId: string;
  workspaceId: string;
  source: string;
  totalEmails: number;
  aiReplyEnabled: boolean;
  manualReply: boolean;
  manualReplyFrom: string;
  callBackRequest: boolean;
  callBackRequestFrom: string;
  emailBody: string;
  emailReplyBody: string;
  emailReplyPrompts: IEmailReplyPrompt[];
  subject: string;
  type: string;
  createdBy: string;
  createdOn: string;
  preferredAccountId: string;
  sendingStrategy: string;
  emailCheck: boolean;
  fromEmail: string;
  metaDetails: any;
  campaignStatus: boolean;
}

export enum AutomatedEmailCampaignType {
  JOB = 'JOB',
  CLIENT_SPOC = 'CLIENT_SPOC',
  SOURCE = 'SOURCE',
  DEFAULT = 'DEFAULT',
  CLIENT = 'CLIENT',
}

export interface IAutomatedEmailCampaignSettingListPayload {
  page: number;
  size: number;
  search: string;
  type: AutomatedEmailCampaignType;
}

export interface IPaginationAPIResponse<T> {
  content: T[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  totalElements: number;
  totalPages: number;
}
export interface IAutomatedEmailCampaignListPayload {
  page: number;
  size: number;
  search: string;
  jobId: string;
  campaignCode: string;
  workspaceId: string;
  sortField: string;
  direction: string;
}

export interface EmailLog {
  jobId: string;
  from: string;
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  body: string;
  status: string;
  createdOn: Date;
  campaignCode: string;
  workSpaceId: string;
  candidateName: string;
  direction: string;
  jobCode: string;
  jobTitle: string;
  messageId: string;
  references: string;
  replyTo: string;
  attachments: IBulkEmailAttachment[];
  candidateId: string;
}

export interface IEmailLogGroup {
  messageId: string;
  messages: EmailLog[];
}

export interface IAutomatedCampaignConfig {
  id: string;
  workspaceId: string;
  lastSubmission: number;
  submissionDuration: string;
  submissionCheck: boolean;
  businessDefinitions: string[];
  recentCampaign: number;
  recentCampaignDuration: string;
  recentCheck: boolean;
  threshold: number;
  createdBy: string;
  createdOn: Date;
  preferredAccountId: string;
  emailCheck: boolean;
  fromName: string;
  fromEmail: string;
  signature: string;
  status: boolean;
  excludeCandidateEmailCheck: boolean;
  excludeCandidateEmail: number;
  excludeCandidateEmailDuration: string;
}
